import useOnClickOutside from './useOnClickOutside';

export { useOnClickOutside };
